'use strict';

function HomeController(
  $rootScope,
  $state,
  $stateParams,
  $window,
  Campaigns,
  iso4217,
  gettextCatalog,
  tmhDynamicLocale,
  amMoment
) {
  let id = $stateParams.id;

  if (id) {
    this.data = Campaigns.get(
      { id: id },
      (res) => {
        if (res.campaign.isFromForms) {
          $window.location.href = res.forms.link;
        } else {
          $rootScope.title = `${res.campaign.title} | ${res.organization.name}`;
          tmhDynamicLocale.set(res.organization.language);
          gettextCatalog.setCurrentLanguage(res.organization.language);
          amMoment.changeLocale(res.organization.language);
          this.data.organization.currency =
            iso4217.getCurrencyByCode(res.account.currency).symbol || '$';

          if (!this.data.campaign.minimumAmount) {
            switch (this.data.account.currency.toUpperCase()) {
              case 'DKK':
                this.data.campaign.minimumAmount = 10;
                break;
              default:
                this.data.campaign.minimumAmount = 1;
                break;
            }
          }
          this.canContribute = function () {
            if (
              res.campaign.status !== 'active' ||
              moment(res.campaign.startDate).startOf('day').isAfter() ||
              (res.campaign.endDate &&
                moment(res.campaign.endDate).startOf('day').isBefore())
            ) {
              return false;
            }
            return true;
          };
        }
      },
      (error) => {
        if (error.status === 404) {
          $state.go('notFound');
        } else {
          $state.go('notFound', { errorCode: 'SERVICE_DOWN' });
        }
      }
    );
  } else {
    $state.go('notFound');
  }
}

angular.module('cdPay.routes.home', []).component('home', {
  templateUrl: 'routes/home/home.html',
  controller: HomeController,
});
